/**
 * Polyfills for older browser compatibility
 * These polyfills help support Android devices from around 2019-2020
 */

// Promise.allSettled polyfill for older browsers
if (!Promise.allSettled) {
  Promise.allSettled = function(promises) {
    return Promise.all(
      promises.map(p => 
        Promise.resolve(p)
          .then(value => ({ status: 'fulfilled', value }))
          .catch(reason => ({ status: 'rejected', reason }))
      )
    );
  };
}

// Object.fromEntries polyfill
if (!Object.fromEntries) {
  Object.fromEntries = function(entries) {
    if (!entries || !entries[Symbol.iterator]) {
      throw new Error('Object.fromEntries requires an iterable object');
    }
    return [...entries].reduce((obj, [key, val]) => {
      obj[key] = val;
      return obj;
    }, {});
  };
}

// String.prototype.replaceAll polyfill
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(pattern, replacement) {
    return this.split(pattern).join(replacement);
  };
}

// Array.prototype.at polyfill
if (!Array.prototype.at) {
  Array.prototype.at = function(index) {
    return this[index < 0 ? this.length + index : index];
  };
}

// Element.prototype.toggleAttribute polyfill
if (!Element.prototype.toggleAttribute) {
  Element.prototype.toggleAttribute = function(name, force) {
    if (force !== undefined) {
      force ? this.setAttribute(name, '') : this.removeAttribute(name);
      return force;
    }
    if (this.hasAttribute(name)) {
      this.removeAttribute(name);
      return false;
    }
    this.setAttribute(name, '');
    return true;
  };
}

// AbortController polyfill stub - for older browsers that might not support it
if (typeof window !== 'undefined' && !window.AbortController) {
  window.AbortController = function() {
    this.signal = {
      aborted: false,
      addEventListener: function() {},
      removeEventListener: function() {},
      dispatchEvent: function() { return false; }
    };
    this.abort = function() {
      this.signal.aborted = true;
    };
  };
}

// crypto.randomUUID — sólo existe en CONTEXTOS SEGUROS (HTTPS, localhost o
// 127.0.0.1). Entrando por IP de la red local (`vite --host` desde el celular,
// http://192.168.x.x:5173) el origen NO es seguro y la función no existe: sin
// esto, `ChatAtlasProvider` explota en el primer render y el ErrorBoundary se
// come la app entera antes de pintar nada. Pasa igual en cualquier navegador,
// no es cosa de mobile.
//
// `crypto.getRandomValues` SÍ está en contextos inseguros, así que el UUID que
// devolvemos es aleatorio de verdad y con formato RFC 4122 v4 válido — hace
// falta que lo sea: varios de estos ids terminan en columnas `uuid` de
// Postgres, que rechazan cualquier otra cosa.
if (typeof crypto !== 'undefined' && typeof crypto.randomUUID !== 'function') {
  crypto.randomUUID = function randomUUID() {
    const bytes = new Uint8Array(16);
    if (typeof crypto.getRandomValues === 'function') {
      crypto.getRandomValues(bytes);
    } else {
      // Último recurso (navegador muy viejo): peor entropía, mismo formato.
      for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // versión 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variante RFC 4122
    const hex = [];
    for (let i = 0; i < 16; i++) hex.push(bytes[i].toString(16).padStart(2, '0'));
    return (
      hex.slice(0, 4).join('') +
      '-' +
      hex.slice(4, 6).join('') +
      '-' +
      hex.slice(6, 8).join('') +
      '-' +
      hex.slice(8, 10).join('') +
      '-' +
      hex.slice(10, 16).join('')
    );
  };
}

console.log('Polyfills loaded for older browser compatibility');
